// Keep guide kit links and contents matched to the visitor's selected color.
(function(window, document) {
  'use strict';

  var productImageFiles = {
    'kit-pen': ['unknown_color_pen_kit.jpg', 'Packaging-PenKit.jpg', 'Packaging-PenKit-Tricoat.jpg'],
    'kit-bottle': ['unknown_color_bottle_kit.jpg', 'Packaging-BottleKit.jpg', 'Packaging-BottleKit-Tricoat.jpg'],
    'kit-spray': ['unknown_color_spray_kit.jpg', 'Packaging-SprayKit.jpg', 'Packaging-SprayKit-Tricoat.jpg']
  };

  function readColor() {
    var match;
    var value;
    try {
      match = String(document.cookie || '').match(/(?:^|;\s*)ps_cc=([^;]*)/);
      value = match && match[1] ? JSON.parse(decodeURIComponent(match[1])) : null;
    } catch (_e) {
      value = null;
    }
    if (!value || !(value.code || value.color || value.color_slug)) return null;
    if (!/^[a-z0-9-]+$/.test(String(value.make_slug || ''))) return null;
    if (!/^[a-z0-9-]+$/.test(String(value.color_slug || ''))) return null;
    return value;
  }

  function addClass(node, className) {
    var current = ' ' + String(node.className || '') + ' ';
    if (current.indexOf(' ' + className + ' ') < 0) {
      node.className = String(node.className || '') + (node.className ? ' ' : '') + className;
    }
  }

  function isTricoat(color, href) {
    if (color && (color.is_tricoat === true || color.is_tricoat === 1 || color.is_tricoat === '1')) return true;
    return /(?:tri-?coat|three-stage)/i.test(String(href || ''));
  }

  function updateProductImage(link, color) {
    var product = link.getAttribute('data-ps-scratch-product');
    var files = productImageFiles[product];
    var card = link.parentNode;
    var image;
    var href = link.getAttribute('href') || '';
    var selected = !!color || /^\/colors\/[a-z0-9-]+\/[a-z0-9-]+\//i.test(href);
    var file;
    var base;
    if (!files || !card || !card.querySelector) return;
    image = card.querySelector('img[data-ps-scratch-product-image]');
    if (!image || !image.setAttribute) return;
    file = selected ? files[isTricoat(color, href) ? 2 : 1] : files[0];
    base = '/cdn/shop/files/' + file;
    image.setAttribute('src', base + '?width=360');
    image.setAttribute('srcset', base + '?width=180 180w, ' + base + '?width=360 360w, ' + base + '?width=533 533w');
    image.setAttribute('sizes', '(max-width: 749px) 100vw, 26rem');
    addClass(link, 'ps-scratch-guide__product-link');
  }

  function updateProductLink(link, color) {
    var product;
    if (!link || !link.getAttribute) return;
    product = link.getAttribute('data-ps-scratch-product');
    if (!/^(pen|bottle|spray|kit-pen|kit-bottle|kit-spray)$/.test(product || '')) return;
    if (!link.getAttribute('data-ps-scratch-default-href')) {
      link.setAttribute('data-ps-scratch-default-href', link.getAttribute('href') || '');
    }
    if (color) {
      link.setAttribute('href', '/colors/' + color.make_slug + '/' + color.color_slug + '/' + product + '/');
    } else {
      link.setAttribute('href', link.getAttribute('data-ps-scratch-default-href'));
    }
    updateProductImage(link, color);
  }

  function updateContents(color) {
    var contents = document.querySelectorAll('p[data-ps-scratch-kit-contents]');
    var note = document.querySelector('p[data-ps-scratch-color-note]');
    var tricoat;
    var regular;
    var i;
    for (i = 0; i < contents.length; i++) {
      if (!contents[i] || !contents[i].getAttribute) continue;
      regular = contents[i].getAttribute('data-ps-scratch-regular-contents');
      tricoat = contents[i].getAttribute('data-ps-scratch-tricoat-contents');
      if (color && isTricoat(color, color.color_slug) && tricoat) contents[i].textContent = tricoat;
      else if (regular) contents[i].textContent = regular;
    }
    if (note) note.hidden = !!color;
  }

  function updateLinks() {
    var links = document.querySelectorAll('.ps-content-page a[data-ps-scratch-product]');
    var color = readColor();
    var i;
    for (i = 0; i < links.length; i++) updateProductLink(links[i], color);
    updateContents(color);
  }

  function observeProductLinks() {
    var root;
    var observer;
    if (!window.MutationObserver) return;
    root = document.querySelector('.ps-content-page');
    if (!root) return;
    observer = new window.MutationObserver(function(mutations) {
      var i;
      var link;
      for (i = 0; i < mutations.length; i++) {
        link = mutations[i] && mutations[i].target;
        if (link && link.getAttribute && link.getAttribute('data-ps-scratch-product')) {
          updateProductImage(link, readColor());
        }
      }
    });
    observer.observe(root, { attributes: true, attributeFilter: ['href'], subtree: true });
  }

  function trackClick(link) {
    var href;
    var action;
    var path;
    if (!link || !window.location) return;
    if (window.location.hostname !== 'www.paintscratch.com' || /(?:^|[?&])ps_test=1(?:&|$)/.test(window.location.search || '')) return;
    href = link.getAttribute('href') || '';
    path = String(window.location.pathname || '');
    if (link.getAttribute('data-ps-scratch-product')) action = 'product';
    else if (/^\/pages\/directions/.test(href)) action = 'directions';
    else if (/^\/pages\/contact-us|^\/pages\/support/.test(href)) action = 'support';
    else if (/^\/scratch-identification\//.test(href)) action = 'category';
    else if (href === '/' || /^\/touch-up-paint-codes\//.test(href)) action = 'color_selection';
    if (!action) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'scratch_guide_click', { guide_action: action, guide_path: path });
    } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'scratch_guide_click', guide_action: action, guide_path: path });
    }
  }

  function onClick(event) {
    var node = event.target;
    var root = document.querySelector('.ps-content-page');
    if (!root) return;
    while (node && node !== root) {
      if (node.tagName && node.tagName.toLowerCase() === 'a') {
        updateProductLink(node, readColor());
        trackClick(node);
        return;
      }
      node = node.parentNode;
    }
  }

  function init() {
    var heroSlot = document.querySelector('[data-ps-content-slot="scratch-hero-media"]');
    if (heroSlot && String(heroSlot.textContent || '').replace(/\s/g, '') === '[PS_CONTENT_SCRATCH_HERO_MEDIA_HTML]') {
      heroSlot.textContent = '';
    }
    if (!document.querySelector('.ps-content-page.ps-scratch-page, .ps-scratch-guide__categories, .ps-scratch-guide__examples')) return;
    updateLinks();
    document.addEventListener('click', onClick);
    document.addEventListener('ps:color:validated', updateLinks);
    document.addEventListener('ps:color:cleared', updateLinks);
    document.addEventListener('ps:color:invalid', updateLinks);
    window.addEventListener('pageshow', updateLinks);
    observeProductLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(window, document);
